import _ from "lodash";
import { flow, types } from "mobx-state-tree";
import { getEnv } from "~/mobx/utils/getEnv";
import { InsuranceCompany } from "./InsuranceCompany";
import type {
  InsuranceCompanyInstance,
  InsuranceCompanySnapshotIn,
} from "./InsuranceCompany";
import type { AxiosResponse } from "axios";
import type { Instance, SnapshotIn, SnapshotOut } from "mobx-state-tree";

export interface InsuranceCompanyStoreInstance
  extends Instance<typeof InsuranceCompanyStore> {}
export interface InsuranceCompanyStoreSnapshotIn
  extends SnapshotIn<typeof InsuranceCompanyStore> {}
export interface InsuranceCompanyStoreSnapshotOut
  extends SnapshotOut<typeof InsuranceCompanyStore> {}

export const InsuranceCompanyStore = types
  .model("InsuranceCompanyStore", {
    map: types.map(InsuranceCompany),
  })
  .actions((self) => {
    return {
      processOne(data: InsuranceCompanySnapshotIn) {
        const existing = self.map.get(data.id);
        if (existing) {
          _.mergeWith(existing, data, (_, next) => {
            if (Array.isArray(next)) return next; // Treat arrays like atoms
          });
          return existing;
        }
        return self.map.put(data as InsuranceCompanySnapshotIn);
      },
    };
  })
  .actions((self) => {
    return {
      processMany(dataList: InsuranceCompanySnapshotIn[]) {
        return dataList.map((data) => {
          return self.processOne(data);
        });
      },
    };
  })
  .actions((self) => {
    return {
      getInsuranceCompanyList: flow<InsuranceCompanyInstance[], []>(
        function* getInsuranceCompanyList(): any {
          const env = getEnv(self);

          const response: AxiosResponse = yield env.baseAuthHttp.get(
            "insurance-companies/",
          );

          const companies = response.data.data;

          response.data = self.processMany(companies);

          return response.data;
        },
      ),
    };
  });
